export const DURATION_OPTIONS = [
    { value: "Hours", label: "Hours" },
    { value: "Days", label: "Days" },
    { value: "Weeks", label: "Weeks" },
    { value: "Months", label: "Months" },
    { value: "Years", label: "Years" },
];

export const LEVEL_OPTIONS = [
    { value: "Beginner", label: "Beginner" },
    { value: "Intermediate", label: "Intermediate" },
    { value: "Advanced", label: "Advanced" },
];

export const PRICING_OPTIONS = [
    { value: "Free", label: "Free" },
    { value: "Premium", label: "Premium" },
];

export const SORT_OPTIONS = [
    { value: "new", label: "Newest" },
    { value: "popular", label: "Most Popular" },
];